import { put, select } from 'redux-saga/effects';
import nsApi from '@netsapiens/netsapiens-js/dist/api';

import * as actions from '../../../state';
import { userAuthenticated } from '../../../events';

export default function* authenticateUser(event) {
  yield put(actions.showLoaderPage());

  const apiHash = yield select((state) => state.configs.apiHash);

  try {
    yield nsApi.authenticate({
      username: event.payload.username,
      password: event.payload.password,
      apiHash,
    });

    yield put(actions.loginFormErrorMsg(null));
    yield put(userAuthenticated());
  } catch (err) {
    if (err.reason === 'MFA_REQUIRED') {
      yield put(actions.showMfaFormPage(
        event.payload.username,
        err.mfa_type,
        err.mfa_vendor,
      ));
    } else {
      yield put(actions.loginFormErrorMsg('Username or password is invalid. Please try again.'));
      yield put(actions.showLoginFormPage());
    }
  }
}
